<script>
import checkoutMixin from '../checkout-mixin'

export default {
	mixins: [checkoutMixin],
	data() {
		return {
			couponCode: '',
			codeChanged: false,
		}
	},
	computed: {
		isApplied() {
			return this.checkout?.order?.discounts?.some((d) => d.triggerType == 'coupon')
		},
		couponError() {
			if (this.codeChanged) return ''
			return (
				this.checkout.stepsData.discount?.validation?.couponCode ||
				this.checkout.validation?.couponCode ||
				''
			)
		},
	},
	watch: {
		couponCode(newVal, oldVal) {
			if (!oldVal) return
			this.codeChanged = true
		},
	},
	methods: {
		removeCoupon() {
			const payload = { noCode: true }
			this.checkout.stepSubmit(payload, 'discount').then((x) => {
				this.codeChanged = false
			})
		},
		submitCoupon() {
			if (!this.couponCode) return
			const payload = {
				key: 'couponCode',
				value: { couponCode: this.couponCode.trim() },
			}
			this.checkout.stepSubmit(payload, 'discount').then((x) => {
				this.codeChanged = false
			})
		},
	},
	mounted() {
		this.couponCode = this.checkout.stepsData.discount?.payload?.value?.couponCode || ''
	},
}
</script>

<template>
	<v-card class="px-4 pt-2 pb-4">
		<div class="font-1 mb-2">Cupón de descuento</div>
		<div class="d-flex" style="gap: 10px">
			<TextField
				class="w100"
				:error-messages="couponError"
				dense
				outlined
				v-model="couponCode"
				placeholder="Código"
				hint="No acumulable con otras promociones"
				:disabled="checkout.submitLoading || (isApplied && !couponError)"
				clearable
				@click:clear="couponCode = ''"
			>
				<template #prepend-inner>
					<v-icon>mdi-tag</v-icon>
				</template>
			</TextField>
			<div class="flex-shrink-0" style="padding-top: 6px">
				<Button
					v-if="!isApplied"
					@click="submitCoupon"
					color="success"
					:loading="checkout.submitLoading"
					small
					:style="{ opacity: couponCode.trim() ? '1' : '0.8' }"
				>
					<v-icon small left>mdi-plus</v-icon> Aplicar
				</Button>
				<Button
					v-else
					@click="removeCoupon"
					small
					color="error"
					outlined
					:loading="checkout.submitLoading"
				>
					<v-icon small left>mdi-close</v-icon> Remover
				</Button>
			</div>
		</div>
	</v-card>
</template>

